import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon
} from "@mui/material";
import { Loading, Tabs, TabContainer, Tooltip } from "@gpstrackit/react-controls"
import { useIntl } from "react-intl";
import { TagsGroup } from 'Components/Tag';

// hook
import { useTokenOneTimeHandler } from 'Core/hooks';
//Actions
import {
    accountsCreateEditAccountOpenModal,
    accountsPromilesRequestOpenModal,
    accountgetDataRequest,
    accountsChangeStatusOpenModal,
    searchEntityRequest,
    resetPasswordOpenModal,
    devicesImportShow,
    reprocessOdoHoursOpenModal,
    changeUsernameOpenModal,
    resetEmailOpenModal,
    resendInviteOpenModal,
    openModalSyncEntities,
    getTokenOneTime,
    getTokenOneTimeResult,
    clearRedux,
} from "Redux/actions";

//Components
import ChipStatus from 'Components/ChipStatus';
import SummaryCard from 'Components/SummaryCard';
import MultiLevelSelector from "Components/SelectorMultiLevel";

//Tabs
import Devices from "Modules/devices/.components/tab";
import KeyFobs from "Modules/keysFobs/.components/tab";
import Users from "Modules/users/.components/tab";
import Activities from "Modules/activities/.components/tab";
import PurgeAccount from '../components/purgeAccount';
import ResetCompanyAuthentication from 'Modules/accounts/views/components/resetCompanyAuthentication';
import ResetPassword from 'Modules/.common/.components/resetPassword';
import SystemAlertLogs from 'Modules/accounts/.components/systemAlertLogsTab'
import SchuduledReports from 'Modules/accounts/.components/scheduledReports';
import CreateEditAccount from 'Modules/accounts/views/components/createEditAccount';
import ChangeStatus from 'Modules/accounts/views/components/changeStatus';
import ImportDevices from 'Modules/devices/.components/importDevices';
import ExportLogs from 'Modules/accounts/.components/exportLogs';
import ScheduledAction from 'Modules/scheduledActions/views/components/tab';
import ChangeUsername from "../../.components/changeUsername";
import PromilesRequest from 'Modules/accounts/views/components/promilesRequest';
import Integrations from 'Modules/accounts/.components/tabIntegrations';
import MaintenanceWarningEvents from 'Modules/maintenanceWarningEvents/views/main';
import ResetEmail from 'Modules/.common/.components/resetEmail';
import ResendInvite from 'Modules/.common/.components/resendInvite';
import SyncEntities from 'Modules/accounts/views/components/syncEntities';
import EdgeTensor from 'Modules/accounts/.components/tabEdgeTensor';
import ApiKeys from 'Modules/accounts/.components/tabApiKeys';

//Helpers
import { getDateFormatted, copyToClipboard, getBadget } from 'Core/data/Helpers';
import { endpoints } from 'Core/defaultValues';

//Permission
import { HasPermission } from "Core/security"
import { set } from "lodash";

const CompanyOverview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();

    const statusOptions = [
        {
            id: 1,
            label: messages['active']
        },
        {
            id: 4,
            label: messages['cancelled']
        },
        {
            id: 3,
            label: messages['involuntary_suspension']
        },
        {
            id: 2,
            label: messages['voluntary_suspension']
        }
    ]

    const { loading, company } = useSelector(state => state.accountOverviewRedux);

    const loadingToken = useSelector(state => state.accountOverviewRedux.loadingToken);
    const deleteScheduledResult = useSelector(state => state.deleteScheduledActionRedux.result);
    const editScheduledActionResult = useSelector(state => state.editScheduledActionRedux.result);
    const createScheduledActionResult = useSelector(state => state.changeStatusAccountRedux.schedule);
    const changeStatusByUnitResult = useSelector(state => state.changeStatusRedux.schedule);
    const purgeAccountOModal = useSelector(state => state.purgeAccountRedux.openModal);
    const createEditAccountOModal = useSelector(state => state.createEditAccountRedux.openModal);
    const changeStatusAccountOModal = useSelector(state => state.changeStatusAccountRedux.openModal);
    const resetCompAuthenticationOModal = useSelector(state => state.resetCompAuthenticationRedux.openModal);
    const resetPasswordOModal = useSelector(state => state.resetPasswordRedux.openModal);
    const importDevicesOpenModal = useSelector(state => state.importDevicesRedux.openModal);
    const promilesRequestOpenModal = useSelector(state => state.promilesRequestRedux.openModal);
    const changeUsernameOpenMo = useSelector(state => state.changeUsernameRedux.openModal);
    const openModalResetEmail = useSelector(state => state.resetEmailRedux.openModal);
    const openModalResendInvite = useSelector(state => state.resendInviteRedux.openModal);
    const openModalSyncZonar = useSelector(state => state.syncEntitiesRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);
    const dealers = useSelector(state => state.generalRedux.dealers);
    const tokenOneTime = useSelector(state => state.accountOverviewRedux.tokenOneTime);

    const { handleAuthenticate } = useTokenOneTimeHandler(tokenOneTime, dealers);
    const { id } = useParams();
    const [tab, setTab] = useState(0);
    const [openSummary, setOpenSummary] = useState(true);


    useEffect(() => {
        dispatch(accountgetDataRequest(id))
        return () => {
            dispatch(clearRedux("ACCOUNT_OVERVIEW"));
            dispatch(clearRedux("COMMON", {
                'keyfobs-tab-account': {},
                'users-account': {},
                'devices-account': {},
                'system-alert-logs': {},
                'scheduled-reports': {},
                'maintenance-warning-events-company': {}
            }))
        }
    }, [])

    useEffect(() => {
        if (deleteScheduledResult?.delete || editScheduledActionResult?.id || createScheduledActionResult?.response || changeStatusByUnitResult?.response) {
            dispatch(accountgetDataRequest(id))
        }
    }, [deleteScheduledResult, editScheduledActionResult, createScheduledActionResult, changeStatusByUnitResult])

    useEffect(() => {
        (!dealers || dealers.length === 0) && dispatch(searchEntityRequest({ key: "dealers" }));
    }, []);

    const SummaryItem = (props) => {
        const { label, value } = props;
        return (
            <Grid item xs={4} sm={4}>
                <div style={{ display: 'grid' }}>
                    <span style={{ opacity: 0.6 }} className="text-muted mb-2">
                        {label}
                    </span>
                    {
                        company ? value() : <div style={{ width: 210, height: 20 }}></div>
                    }
                </div>
            </Grid>
        )
    }

    let activitiesTab = HasPermission(user, "act");
    let devicesTab = HasPermission(user, "unt");
    let keyFobsTab = HasPermission(user, "kfb");
    let usersTab = HasPermission(user, "subusr");
    let systemAlertLogsTab = HasPermission(user, "sysal");
    let scheduledReportsTab = HasPermission(user, "schrl");
    let exportLogsTab = HasPermission(user, "exprlog");
    let scheduledActionsTab = HasPermission(user, "schact");
    let integrationsTab = HasPermission(user, "intgrtns");
    let warningsTab = HasPermission(user, "wrgs");
    let edgeTensorTab = HasPermission(user, "edgtnsr");
    let apiKeysTab = HasPermission(user, "cmp");
    let indexCount = 0;

    let innerHeight = window.innerHeight
    let zonarIntegration = (company && company?.integrations?.length) ? company?.integrations?.some(integration => integration?.integration?.code === "zonar") : false

    return (
        <Container maxWidth={false} className="container-view">
            {(loading || loadingToken) && <Loading overlay show />}
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8" }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={6}>
                                <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton onClick={() => navigate(-1)} size="large">
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                            arrow_back
                                        </Icon>
                                    </IconButton>
                                    <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['account_overview_title']}:</span> {company?.name ? `${company.name?.substring(0, 30)} (${company.id})` : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: 'end' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    {
                                        HasPermission(user, "cmplc") &&
                                        <a
                                            style={{ marginRight: 10, color: 'black', cursor: 'pointer', textDecoration: 'underline' }}
                                            onClick={(e) => {
                                                handleAuthenticate(e, company?.dealer?.id, company?.email || company?.username, `PX_${company?.id}`)
                                            }}
                                        >
                                            {messages['accounts_main_authenticate_cloud']}
                                        </a>
                                    }
                                    <MultiLevelSelector
                                        label={messages['account_overview_actions']}
                                        position="left"
                                        options={[
                                            {
                                                id: "edit_account",
                                                label: messages['account_overview_edit_account'],
                                                show: true,
                                                action: () => {
                                                    dispatch(accountsCreateEditAccountOpenModal(company))
                                                },
                                                disabled: !HasPermission(user, "cmp", "u"),
                                            },
                                            {
                                                id: "credentials_account",
                                                label: messages['account_overview_credentials'],
                                                show: true,
                                                submenu: [
                                                    {
                                                        id: "reset_account_passowrd",
                                                        label: messages['account_overview_reset_account_password'],
                                                        show: company?.registrationStatus === "Active" ? true : false,
                                                        action: () => {
                                                            let entity = { ...company, entityName: "Account" }
                                                            dispatch(resetPasswordOpenModal(entity))
                                                        },
                                                        disabled: !HasPermission(user, "cmprap", "u"),
                                                    },
                                                    {
                                                        id: "reset_account_email",
                                                        label: messages['account_overview_reset_account_email'],
                                                        show: true,
                                                        action: () => {
                                                            let entity = { ...company, entityName: "Account" }
                                                            dispatch(resetEmailOpenModal({ entity, callback: () => dispatch(accountgetDataRequest(id)) }))
                                                        },
                                                        disabled: !HasPermission(user, "rsteml", "u"),
                                                    },
                                                    {
                                                        id: "change_username",
                                                        label: messages['account_overview_change_username'],
                                                        show: true,
                                                        action: () => {
                                                            dispatch(changeUsernameOpenModal({ currentUsername: company.username, entityId: company.id, masterUser: true }))
                                                        },
                                                        disabled: !HasPermission(user, "cmpcu", "u"),
                                                    },
                                                    {
                                                        id: "resend_invite",
                                                        label: messages['account_overview_resend_invite'],
                                                        show: company?.registrationStatus !== "Active" ? true : false,
                                                        action: () => {
                                                            let entity = { ...company, entityName: "Account" }
                                                            dispatch(resendInviteOpenModal({ entity, callback: () => dispatch(accountgetDataRequest(id)) }))
                                                        },
                                                        disabled: !HasPermission(user, "rsndinvt", "u") && company?.registrationStatus === "Expired",
                                                    }

                                                ]
                                            },
                                            {
                                                id: "change_account_status",
                                                label: messages['account_overview_change_account_status'],
                                                show: true,
                                                action: () => {
                                                    dispatch(accountsChangeStatusOpenModal(company))
                                                },
                                                disabled: !HasPermission(user, "cmpcas", "u"),
                                            },
                                            {
                                                id: "import_and_assign",
                                                label: messages['account_overview_import_and_assign'],
                                                show: true,
                                                action: () => {
                                                    dispatch(devicesImportShow());
                                                },
                                                disabled: !HasPermission(user, "impdv", "c"),
                                            },
                                            {
                                                id: "reprocess_odo_hours",
                                                label: messages['accounts_main_reprocess_odo_hours'],
                                                show: true,
                                                action: () => {
                                                    dispatch(reprocessOdoHoursOpenModal({ selectedAccount: company }))
                                                },
                                                disabled: !HasPermission(user, "rprcssoh", "c"),
                                            },

                                            {
                                                id: "promiles-request",
                                                label: messages['account_overview_promiles_request'],
                                                show: true,
                                                action: () => {
                                                    dispatch(accountsPromilesRequestOpenModal(company))
                                                },
                                                disabled: !HasPermission(user, "prmr", "u"),
                                            },
                                            ...(zonarIntegration) ? [{
                                                id: "sync-entities",
                                                label: messages['account_overview_syncZonar'],
                                                show: true,
                                                action: () => {
                                                    dispatch(openModalSyncEntities({ account: company }));
                                                },
                                                disabled: !HasPermission(user, "synczon", "u"),
                                            }] : [],
                                        ]}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>
                        <SummaryCard
                            onChange={(value) => setOpenSummary(value)}
                            name="accounts-summary"
                        >
                            <Grid container>
                                <SummaryItem
                                    label={messages['account_overview_username']}
                                    value={() => {
                                        return (
                                            <div style={{ height: 25, display: 'flex', alignItems: 'center' }}>
                                                <div >
                                                    {company?.username}
                                                </div>
                                                <div style={{ marginLeft: 5 }}>

                                                    <TagsGroup
                                                        options={company?.tags ? JSON.parse(company?.tags) : []}
                                                        nameField="label"
                                                        colorField="color"
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_email']}
                                    value={() => {
                                        return (
                                            <div style={{ height: 25, display: 'flex' }}>
                                                {company?.email &&
                                                    <>
                                                        <span>{company?.email}</span>
                                                        <Icon style={{ cursor: "pointer", marginLeft: 5, color: 'rgba(0, 0, 0, 0.54)', fontSize: 18 }} className="toolbar-list-icon" onClick={() => { copyToClipboard(company?.email, messages['common_copied']) }}>
                                                            content_copy
                                                        </Icon>
                                                    </>
                                                }
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_opened_at']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.createdOn && getDateFormatted(company?.createdOn, "date", "datetime")}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_status']}
                                    value={() => {
                                        let nextScheduledAction = company?.nextScheduledAction
                                        let message = null
                                        if (nextScheduledAction) {
                                            try {
                                                let data = JSON.parse(nextScheduledAction)
                                                message = `${messages['accounts_main_next_scheduled_action']}:`
                                                if (data && data?.action === "statusUpdate") {
                                                    let status = statusOptions.find(item => item?.id === data?.data?.newStatusId)
                                                    if (data?.entityName === "Account") {
                                                        message = `${messages[data?.action] || data?.action}${status ? ` ${messages[status?.label] || status?.label}` : ''} ${messages['accounts_main_at']} ${data?.scheduleOn}`
                                                    } else if (data?.entityName === "Unit") {
                                                        message = `${messages[data?.action] || data?.action}${status ? ` ${messages[status?.label] || status?.label}` : ''} ${messages['accounts_main_on']} ${messages['accounts_main_devices']} ${messages['accounts_main_at']} ${data?.scheduleOn}`
                                                    }
                                                }
                                            } catch (exc) { }
                                        }

                                        return (
                                            <div style={{ display: 'flex', width: 210, height: 25 }}>
                                                <ChipStatus statusCode={company?.status} messages={messages} />
                                                {nextScheduledAction &&
                                                    <div style={{ marginLeft: 5 }}>
                                                        <Tooltip title={message}>
                                                            <Icon style={{ color: '#1664f5', cursor: 'pointer' }}>access_alarms</Icon>
                                                        </Tooltip>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_active_devices']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.devicesCount || 0}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_dealer']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.dealer?.name || ''}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_brand']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.dealer?.brand?.title || ''}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_package']}
                                    value={() => {
                                        return (
                                            <NavLink to={`/app/packages/overview/${company?.role?.id}`} style={{ color: 'black' }}>
                                                <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{company?.role?.name}</span>
                                            </NavLink>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_terms_conditions']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.tacRequired ? messages['common_yes'] : messages['common_no']}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_crm']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                <a
                                                    style={{ color: 'black' }}
                                                    href={`${endpoints.SALESFORCE_URL}lightning/r/Account/${company?.crmId}/view`}
                                                    target="_blank"
                                                >
                                                    {company?.crmId}
                                                </a>

                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_registration_status']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.registrationStatus && <ChipStatus label={company?.registrationStatus} messages={messages} />}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['account_overview_readonly']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {company?.readonly ? messages['common_yes'] : messages['common_no']}
                                            </div>
                                        )
                                    }}
                                />
                            </Grid>
                        </SummaryCard>

                        <Tabs onChange={(numberTab) => { setTab(numberTab) }}>
                            {
                                devicesTab &&
                                <TabContainer index={indexCount++} key={`menu-${0}`} className={`AccountOverview-menu-${0}`} label={messages['account_overview_devices']}>
                                    {company?.id &&
                                        <Devices
                                            tab={tab}
                                            companyId={company.id}
                                            company={company}
                                            height={openSummary ? innerHeight - 457 : innerHeight - 257}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                activitiesTab &&
                                <TabContainer index={indexCount++} key={`menu-${1}`} className={`AccountOverview-menu-${1}`} label={messages['account_overview_activities']}>
                                    {company?.id &&
                                        <Activities
                                            tab={tab}
                                            companyId={company.id}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            entityName="Company"
                                            companyName={company?.name}
                                            noFilters
                                            noOpenSearch
                                            companyUsername={company?.username}
                                            entity={"activitiesTabAccounts"} instanceId="accounts-overview"
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                keyFobsTab &&
                                <TabContainer index={indexCount++} key={`menu-${2}`} className={`AccountOverview-menu-${2}`} label={messages['account_overview_keysfobs']}>
                                    {company?.id &&
                                        <KeyFobs
                                            tab={tab}
                                            companyId={company.id}
                                            company={company}
                                            height={openSummary ? innerHeight - 457 : innerHeight - 257}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                usersTab &&
                                <TabContainer index={indexCount++} key={`menu-${3}`} className={`AccountOverview-menu-${3}`} label={messages['account_overview_user']} >
                                    {company?.id &&
                                        <Users
                                            tab={tab}
                                            companyId={company.id}
                                            company={company}
                                            height={openSummary ? innerHeight - 457 : innerHeight - 257}
                                            tacRequired={company?.tacRequired}
                                            loading={loading}
                                            handleAuthenticate={handleAuthenticate}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                systemAlertLogsTab &&
                                <TabContainer index={indexCount++} key={`menu-${4}`} className={`AccountOverview-menu-${4}`} label={messages['account_overview_system_alert_logs']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <SystemAlertLogs
                                            tab={tab}
                                            company={company}
                                            height={openSummary ? innerHeight - 457 : innerHeight - 257}
                                            className="range-date-modal"
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                scheduledReportsTab &&
                                <TabContainer index={indexCount++} key={`menu-${5}`} className={`AccountOverview-menu-${5}`} label={messages['account_overview_scheduled_reports']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <SchuduledReports
                                            company={company}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                exportLogsTab &&
                                <TabContainer index={indexCount++} key={`menu-${6}`} className={`AccountOverview-menu-${6}`} label={messages['account_overview_export_logs']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <ExportLogs
                                            company={company}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                scheduledActionsTab &&
                                <TabContainer index={indexCount++} key={`menu-${7}`} className={`AccountOverview-menu-${7}`} label={messages['account_overview_scheduled_actions']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <ScheduledAction
                                            company={company}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                integrationsTab &&
                                <TabContainer index={indexCount++} key={`menu-${8}`} className={`AccountOverview-menu-${8}`} label={messages['account_overview_integrations']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <Integrations
                                            company={company}
                                            companyId={company?.id}
                                            height={openSummary ? innerHeight - 800 : innerHeight - 300}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                warningsTab &&
                                <TabContainer index={indexCount++} key={`menu-${9}`} className={`AccountOverview-menu-${9}`} label={messages['account_overview_warnings']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <MaintenanceWarningEvents
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                            tabMode={true}
                                            companyId={company?.id}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                edgeTensorTab &&
                                <TabContainer index={indexCount++} key={`menu-${10}`} className={`AccountOverview-menu-${10}`} label={messages['account_overview_edge_tensor']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <EdgeTensor
                                            company={company}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                            mode={"tab"}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                apiKeysTab &&
                                <TabContainer index={indexCount++} key={`menu-${11}`} className={`AccountOverview-menu-${11}`} label={messages['account_overview_api_keys']}>
                                    {
                                        company?.id && (indexCount - 1 === tab) &&
                                        <ApiKeys
                                            company={company}
                                            height={openSummary ? innerHeight - 500 : innerHeight - 300}
                                        />
                                    }
                                </TabContainer>
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </Paper>
            {purgeAccountOModal && <PurgeAccount />}
            {createEditAccountOModal && <CreateEditAccount getCompany={() => dispatch(accountgetDataRequest(id))} />}
            {changeStatusAccountOModal && <ChangeStatus company={company} getCompany={() => dispatch(accountgetDataRequest(id))} />}
            {resetCompAuthenticationOModal && <ResetCompanyAuthentication />}
            {importDevicesOpenModal && <ImportDevices company={company} />}
            {changeUsernameOpenMo && <ChangeUsername getCompany={() => dispatch(accountgetDataRequest(id))} />}
            {promilesRequestOpenModal && <PromilesRequest />}
            {resetPasswordOModal && <ResetPassword />}
            {openModalResetEmail && <ResetEmail />}
            {openModalResendInvite && <ResendInvite />}
            {openModalSyncZonar && <SyncEntities />}
        </Container>
    );
}
export default CompanyOverview;